export const blockIconsCommonactionsCodeNew = (
	<span className='material-symbols-outlined'>code</span>
);
